import styled from 'styled-components';
import { Box } from '@rsos/base-components';
import { TOOLTIP_HEIGHT } from './CommunicationHistoryTable.styles';

export const CONTAINER_HEIGHT = 280;

export const Container = styled(Box).attrs(({ theme }) => ({
  justify: 'start',
  border: `1px solid ${theme.colors.heavyLineOutline}`,
  borderRadius: '5px',
  height: CONTAINER_HEIGHT,
}))`
  overflow-x: hidden;
  overflow-y: auto;
`;
export const IconWrapper = styled(Box).attrs(({ theme }) => ({
  justify: 'center',
  border: `1px solid ${theme.colors.heavyLineOutline}`,
  borderRadius: '5px',
  height: TOOLTIP_HEIGHT,
  width: TOOLTIP_HEIGHT,
  align: 'center',
}))`
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
`;

export const NoResults = styled(Box).attrs(({ theme }) => ({
  justify: 'center',
  border: `1px solid ${theme.colors.heavyLineOutline}`,
  borderRadius: '5px',
  height: CONTAINER_HEIGHT,
  align: 'center',
}))``;
